<template>
    <p class="text-xs mt-4 font-light">
        Job code: MED-US-GO1-2500020<br />
        Date of preparation: April 2025
    </p>
</template>